const title = document.querySelectorAll('.left-content__text');
const drawers = document.querySelectorAll('.drawer');

title.forEach((title, index) => {

    title.addEventListener('mouseenter', () => {
        drawers[index].style.left = '0';
    });

    title.addEventListener('mouseleave', () => {
        hideDrawers();
    });
});

function hideDrawers() {
    drawers.forEach(drawer => {
        drawer.style.left = '-100%';
    });
}
